import {
  MissingAnswerMessageContainer,
  QuestionOptionContainer,
  StyledErrorMessage,
  StyledOptionContainer,
} from "./components";
import { QuestionWithRelations } from "../../../../../api/src/types";
import { IconSize } from "../../../components/theme";
import Checkbox from "../../../components/icons/Checkbox";
import { ParagraphSmall } from "../../../components/typography/Paragraph";

interface ReadOnlyTextBoxAreaProps {
  question: QuestionWithRelations;
  missingAnswerMessage: string;
}

const ReadOnlyTextBoxArea: React.FC<ReadOnlyTextBoxAreaProps> = ({
  question,
  missingAnswerMessage,
}) => {
  const valueTyped = question.answers[0]?.valueTyped ?? null;
  if (valueTyped === null) {
    return (
      <MissingAnswerMessageContainer>
        <StyledErrorMessage>{missingAnswerMessage}</StyledErrorMessage>
      </MissingAnswerMessageContainer>
    );
  }
  return (
    <QuestionOptionContainer data-testid="read-only-text-box-area">
      <StyledOptionContainer isChecked={true}>
        <Checkbox isChecked={true} size={IconSize.M} />
        <ParagraphSmall fontWeight={300} textAlign="left">
          {valueTyped}
        </ParagraphSmall>
      </StyledOptionContainer>
    </QuestionOptionContainer>
  );
};

export default ReadOnlyTextBoxArea;
